import { render, staticRenderFns } from "./SpreadViews.vue?vue&type=template&id=4abe211e"
import script from "./SpreadViews.vue?vue&type=script&lang=js"
export * from "./SpreadViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4abe211e')) {
      api.createRecord('4abe211e', component.options)
    } else {
      api.reload('4abe211e', component.options)
    }
    module.hot.accept("./SpreadViews.vue?vue&type=template&id=4abe211e", function () {
      api.rerender('4abe211e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/views-page/SpreadViews.vue"
export default component.exports